import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDDialogTitle } from '@facet-wealth/design';


export default buildFacetDesignOverride()
  .nameOverride('title', { _component: () => FDDialogTitle }, overrideReadOnly);
